// extracted by mini-css-extract-plugin
module.exports = {"btnGrey32":"BtnGrey32_btnGrey32__31xoU"};